import { render, staticRenderFns } from "./ContactInputSearchV2.vue?vue&type=template&id=96cb7b94&scoped=true&"
import script from "./ContactInputSearchV2.vue?vue&type=script&lang=js&"
export * from "./ContactInputSearchV2.vue?vue&type=script&lang=js&"
import style0 from "./ContactInputSearchV2.vue?vue&type=style&index=0&id=96cb7b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cb7b94",
  null
  
)

export default component.exports